import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export const LoadingBackdrop: React.FC = () => (
  <Backdrop
    open
    invisible
    sx={({ zIndex }) => ({
      zIndex: zIndex.drawer + 1,
      color: "white",
    })}
  >
    <CircularProgress color="primary" />
  </Backdrop>
);
